import moment from 'moment';
import Cookies from 'universal-cookie';

const formatTime = (date) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  if (!date) return null;
  const d = moment.tz(date, timezone);
  const hh = String(d.get('hours')).padStart(2, '0');
  const mm = String(d.get('minutes')).padStart(2, '0');
  const ss = String(d.get('seconds')).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
};

const postCreateGiveawayRequest = (formValues) => {
  const payload = {
    brandId: formValues?.brandId?.id,
    title: formValues?.title,
    giveaways: formValues?.giveaways?.map((giveaway) => ({
      productName: giveaway?.productName,
      totalStock: parseInt(giveaway?.totalStock),
      imagePath: giveaway?.imagePath?.key,
      rules: {
        note: giveaway?.rules?.note,
        minimumPurchaseAmount: giveaway?.rules?.minimumPurchaseAmount ? parseInt(String(giveaway?.rules?.minimumPurchaseAmount).replace(/\./g, '')) : 0,
        type: giveaway?.rules?.type?.value,
        requiredProducts: giveaway?.rules?.requiredProducts
          ?.filter((item) => item.productName)
          .map((product) => ({
            sku: product?.sku,
            productName: product?.productName,
            imagePath: product?.isManual ? product?.imageKey : product?.imagePath,
            isManual: Boolean(product?.isManual),
          })),
      },
      sessions: giveaway?.sessions?.map((session) => ({
        promotionDate: moment(session?.promotionDate).format('YYYY-MM-DD'),
        startTime: formatTime(session?.startTime),
        endTime: formatTime(session?.endTime),
        allocatedStock: parseInt(session?.allocatedStock),
        accountLivestreamId: session?.accountLivestreamId?.value,
      })),
    })),
  };
  
  return payload;
};

export default postCreateGiveawayRequest;
